import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { push, replace } from 'react-router-redux'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { save, load } from "redux-localstorage-simple"
import update from 'immutability-helper'
import $ from 'jquery'

import React from 'react'
import { render } from 'react-dom'

// import ObjectsHelper from 'helpers/Objects'

export default class BaseCore {
    _store = null

    history = false

    initialState = {
        routing: {}
    }

    allowLogger = true

    localData = []

    middlewares = []

    Log(...args) {
        console.log(...args)
    }

    initializeStore() {
        this._store = this.configureStore()
    }

    get reducer() {
        const router = connectRouter(this.history)

        console.log('[BaseCore][Get: reducer]',this.history)

        return ( state, action ) => {
            if( action.type == 'updateStore' )
            {
                state = {
                    ...state,
                    ...action.payload,
                }
            }

            return {
                ...state,
                router: router(state.router, action)
            }
        }
    }

    get store() {
        return this._store
    }

    logAction = ( name, args ) => {
        console.log( `%caction %c@${name}%c(${ JSON.stringify( args, null, "    ") })`,
            `color: rgba(0,0,0,0.6)`,
            `font-weight: bold; color: #F78156;`,
            `color: rgba(0,0,0,0.6)`,
        )
    }

    updateStore = ( stateDiff, logName = 'Unnamed action' ) => {
        console.log( `%cUpdate %cstore %c@${ logName }: %O`,
            `color: #3F7CE9`,
            `color: #fff`,
            `font-weight: bold; color: #F78156`,
            stateDiff
        )

        const currentState = this.store.getState()

        try {
            const nextState = update( currentState, stateDiff )

            this.store.dispatch({
                type: 'updateStore',
                payload: nextState
            })
        } catch(e) {
            console.error( 'Fail update store' )
            console.error( 'Prev state: ', currentState )
            console.error( 'Diff state: ', stateDiff )
            console.error( 'Error:', e )
        }
    }

    configureStore = () => {
        let middleware_list = [ thunk ]

        if( this.localData && this.localData.length > 0 )
        {
            middleware_list.push( save({ states: this.localData }) )
        }

        if( this.allowLogger )
        {
            middleware_list.push( createLogger() )
        }

        if( this.history )
        {
            middleware_list.push( routerMiddleware( this.history ) )
        }

        if( this.middlewares && this.middlewares.length > 0 )
        {
            middleware_list = [ ...middleware_list, ...this.middlewares ]
        }

        const createStoreWithMiddleware = applyMiddleware( ...middleware_list )( createStore )

        let initialState = { ...this.initialState }

        if( this.localData && this.localData.length > 0 )
        {
            initialState = {
                ...initialState,
                ...load({ states: this.localData })
            }
        }

        return createStoreWithMiddleware( this.reducer, initialState )
    }
    
    historyPush( to ) {
        this.store.dispatch( push( `${to}` ) )
    }

    historyReplace( to ) {
        this.store.dispatch( replace( `${to}` ) )
    }

    renderApp(selector, ReactComponent) {
        const dom_container = document.querySelector(selector)

        if (dom_container) {
            render(
                <ReactComponent />,
                dom_container
            )
        } else {
            throw new Error(`Selector not found on dom: ${selector}`)
        }
    }

    run(selector, StartComponent) {
        window.$ = $
        window.AppCore = this

        this.renderApp(selector, StartComponent)
    }
}